// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid-container-2 {
  display: grid;
  gap: 10px;
  /* word-break: break-all; */
  grid-template-columns: 1.2fr 1fr;
  /* grid-template-columns: repeat(2, 1fr); */
}
`, "",{"version":3,"sources":["webpack://./src/containers/eventDetails/modalChildren/details_responsive/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,gCAAgC;EAChC,2CAA2C;AAC7C","sourcesContent":[".grid-container-2 {\n  display: grid;\n  gap: 10px;\n  /* word-break: break-all; */\n  grid-template-columns: 1.2fr 1fr;\n  /* grid-template-columns: repeat(2, 1fr); */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
